import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import Collapsible from 'react-collapsible';
import {
  scrollToHandler,
  updateSideBarOrderCookie,
} from '../../../Utils/StoreHomePageUtils';
import { getScreenName } from '../../../Utils/helper';
import { getRouterLocale } from '../../../Utils/i18Utils/constant';
import { getSearchParams } from '../../Parenting/common';
import AnchorCoverTag from '../../StoreHomePage/AnchorCoverTag';
import MenuTitle from './MenuTitle';
import { LtwoCategoryBg, MenuListTitle } from './styled';
import { fireEvent } from '../../../Utils/fireEvent';

export default function DropDownItems(props) {
  const {
    category,
    index,
    categoryClickHandler,
    setDrawerOpen,
    childCategory,
    childlevel,
    cardEffect,
    baseId,
    initialOrder,
    countShow,
    index_blurred,
    trackOrderHandler,
  } = props;

  const router = useRouter();
  const [activeIndex, setActiveIndex] = useState(-1);
  const [clickEffectIndex, setClickEffectIndex] = useState(-1);
  const [maxShowitems, setShowMaxItems] = useState(countShow || null);
  const [clickEffect, setClickEffect] = useState('');
  useEffect(() => {
    if (router?.query?.category?.includes(category?._id)) {
      setActiveIndex(index);
    }
  }, [router?.query]);
  const expandedEvent = (level, itemType, parent, itemName) => {
    fireEvent({
      category: 'expanded_sidedrawer_item',
      screen_name: getScreenName(),
      // item_type: "parent",
      item_name: itemName,
      item_level: level,
      item_type: itemType,
      parent: parent ? parent : 'NA',
    });
  };
  const collapsedEvent = (level, itemType, parent, itemName) => {
    fireEvent({
      category: 'collapsed_sidedrawer_item',
      screen_name: getScreenName(),
      // item_type: "parent",
      item_name: itemName,
      item_level: level,
      item_type: itemType,
      parent: parent ? parent : 'NA',
    });
  };
  const scrollHandler = () => {
    scrollToHandler('allProducts');
    setDrawerOpen(false);
  };
  const callbackFunction = (index, deeplinkValue, element, e, obj) => {
    // setCardEffect({ index: index, effect: "lowOpacity" });
    setTimeout(() => {
      router.push(`${deeplinkValue}` + getSearchParams(obj), '', {
        locale: getRouterLocale(router),
      });
    }, [200]);
  };
  return (
    <Collapsible
      trigger={
        <MenuTitle
          index={index}
          activeIndex={activeIndex}
          title={category?.tabName}
          subCategoryLength={category?.subCategories?.length || 0}
          category={category}
          categoryClickHandler={
            category.position && category.tabName == 'ALL PRODUCTS'
              ? scrollHandler
              : () => categoryClickHandler(category, index)
          }
          childCategory={childCategory}
          childlevel={childlevel}
          cardEffect={cardEffect}
          index_blurred={index_blurred}
          trackOrderHandler={trackOrderHandler}
        />
      }
      // triggerDisabled={!category?.key}
      transitionTime={200}
      onOpening={() => {
        setShowMaxItems(null);
        setActiveIndex(index);
      }}
      onClosing={() => {
        activeIndex == index ? setActiveIndex(-1) : null;
      }}
      open={activeIndex == index ? true : false}
      onOpen={() => expandedEvent('L1', 'parent', '', category?.tabName)}
      onClose={() => collapsedEvent('L1', 'parent', '', category?.tabName)}
    >
      {category?.subCategories?.map((element, innerIndex) => {
        const web_url = element?.key || element?.fabDeeplinkValue;
        // if (maxShowitems && innerIndex >= maxShowitems) return null;
        // const blurredIndex = maxShowitems - 1;
        // const index_blurred = blurredIndex === innerIndex;
        const number_of_items = category?.subCategories?.length;
        const remainingCount = number_of_items - maxShowitems;
        return (
          <>
            <LtwoCategoryBg
              lastIndex={innerIndex === category?.subCategories?.length - 1}
              childlevel={childlevel}
              className={`${index_blurred ? 'blurred' : ''} ${
                !element?.subCategories ? 'borderLeft' : ''
              }`}
              // key={`dropdownL2Categories${innerIndex}`}
            >
              {element?.subCategories?.length > 0 ? (
                <>
                  <DropDownItems
                    key={`dropDownItems${innerIndex}`}
                    category={element}
                    index={innerIndex}
                    categoryClickHandler={categoryClickHandler}
                    setDrawerOpen={setDrawerOpen}
                    childCategory={true}
                    childlevel={childlevel + 1}
                    baseId={baseId + ',' + innerIndex}
                    initialOrder={
                      activeIndex != index.toString()
                        ? [index, -1, -1, -1]
                        : initialOrder
                    }
                    index_blurred={index_blurred && remainingCount !== 0}
                  />
                </>
              ) : (
                <>
                  <AnchorCoverTag
                    url={web_url}
                    key={`listItemsSideDrawer${innerIndex}`}
                    cardEffect={
                      innerIndex === clickEffectIndex ? 'lowOpacity' : ''
                    }
                    element={element}
                    callbackFunction={callbackFunction}
                  >
                    <div
                      id={baseId + ',' + innerIndex}
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        categoryClickHandler(
                          element,
                          innerIndex,
                          category?.tabName,
                        );

                        updateSideBarOrderCookie(baseId + ',' + innerIndex);
                        setClickEffectIndex(innerIndex);
                        setTimeout(() => {
                          router.push(web_url + getSearchParams(), '', {
                            locale: getRouterLocale(router),
                          });
                        }, [200]);
                        setTimeout(() => {
                          setClickEffectIndex(-1);
                        }, [2000]);
                      }}
                    >
                      <MenuListTitle
                        ltwoCat
                        childlevel={childlevel + 1}
                        className={!element?.subCategories ? 'l3padding' : ''}
                      >
                        <p className={childlevel != 0 && 'ellipsisText'}>
                          {element?.tabName?.toLowerCase()}
                        </p>
                      </MenuListTitle>
                    </div>
                  </AnchorCoverTag>
                </>
              )}
              {/* {index_blurred && remainingCount !== 0 ? (
                                <div
                                    className={`seeMoreText `}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setClickEffect("lowOpacity");
                                        setTimeout(() => {
                                            setClickEffect("");
                                            if (remainingCount === 0) {
                                                setShowMaxItems(countShow);
                                            } else {
                                                setShowMaxItems(
                                                    number_of_items,
                                                );
                                            }
                                        }, 200);
                                    }}
                                >
                                    <p className={` ${clickEffect}`}>
                                        See More ({remainingCount})
                                        <img
                                            src={images.arrowDownForward}
                                            alt={"verm_down"}
                                        />
                                    </p>
                                </div>
                            ) : null} */}
            </LtwoCategoryBg>
          </>
        );
      })}
    </Collapsible>
  );
}
